import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
export default (function (props) {
  var arr = React.Children.toArray(props.children);
  var splits = [];
  var slides = [];
  slides.head = {
    props: {},
    children: []
  };
  var notes = {};
  arr.forEach(function (child, i) {
    var _child$props = child.props,
        originalType = _child$props.originalType,
        mdxType = _child$props.mdxType,
        parentName = _child$props.parentName,
        children = _child$props.children,
        childProps = _objectWithoutPropertiesLoose(_child$props, ["originalType", "mdxType", "parentName", "children"]); // todo: figure out nested decks
    // if (originalType.isMDXComponent) {}
    // get notes


    if (originalType.__mdxDeck_notes || mdxType === 'Notes') {
      notes[splits.length] = children;
    } else if (originalType.__mdxDeck_header || mdxType === 'Header') {
      slides.header = children;
    } else if (originalType.__mdxDeck_footer || mdxType === 'Footer') {
      slides.footer = children; // get head content
    } else if (originalType.__mdxDeck_head || mdxType === 'Head') {
      slides.head.children.push(children);
      Object.assign(slides.head.props, childProps);
    }

    if (mdxType === 'hr') {
      splits.push(i);
    }
  });
  var previousSplit = 0;
  splits.forEach(function (split, i) {
    var children = _toConsumableArray(arr.slice(previousSplit, split));

    if (notes[i]) children.notes = notes[i];
    slides.push(children);
    previousSplit = split + 1;
  });

  var last = _toConsumableArray(arr.slice(previousSplit));

  if (notes[slides.length]) last.notes = notes[slides.length];
  slides.push(last);
  slides.head.children = React.Children.toArray(slides.head.children).map(function (child, i) {
    var _child$props2 = child.props,
        originalType = _child$props2.originalType,
        mdxType = _child$props2.mdxType,
        parentName = _child$props2.parentName,
        childProps = _objectWithoutPropertiesLoose(_child$props2, ["originalType", "mdxType", "parentName"]);

    return React.createElement(originalType, _objectSpread({
      key: i
    }, childProps));
  });
  return slides;
});